const PARROT_ACADEMY_BASE_URL = `${process.env.REACT_APP_PARROT_ACADEMY_BASE_URL}/suscripcion`;

export const SUBSCRIPTION_ACADEMY_LINKS = {
  SUBSCRIPTION: `${PARROT_ACADEMY_BASE_URL}/suscripcion-v2`,
} as const;
